import React, { useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import NavigationButton from '../shared/Buttons/NavigationButton';
import { ProductImages } from '../../models/Product';

const StyledWrapper = styled(Box)(({ theme }) => ({
    paddingRight: '60px',
    [theme.breakpoints.down('sm')]: {
        paddingRight: '0',
        paddingBottom: '10px',
    },
}));

const SelectedImageWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
        padding: '10px 0',
    },
}));

const SelectedImage = styled(Box)(({ theme }) => ({
    img: {
        width: '100%',
    },
}));

const ImageSelectorWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    padding: '10px 0',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
}));

const ImageWrapper = styled(Box)(({ theme }) => ({
    // width: '211px',
    width: '150px',
    padding: '0 10px',
    [theme.breakpoints.down('md')]: {
        width: '80px',
    },
}));

const ImageThumbnail = styled('div')(({ theme }) => ({
    display: 'block',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    cursor: 'pointer',
    '&.selected': {
        opacity: '0.2',
    },
    img: {
        width: '100%',
    },
}));

export const ProductImagesView = (props: { images: ProductImages[] }) => {
    const images = props.images;
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const changeSelectedImage = (event, index) => {
        setSelectedImageIndex(index);
    };

    const nextImage = () => {
        if (images.length - 1 <= selectedImageIndex) {
            setSelectedImageIndex(0);
        } else {
            setSelectedImageIndex(selectedImageIndex + 1);
        }
    };

    const prevImage = () => {
        if (selectedImageIndex == 0) {
            setSelectedImageIndex(images.length - 1);
        } else {
            setSelectedImageIndex(selectedImageIndex - 1);
        }
    };

    return (
        <StyledWrapper>
            <SelectedImageWrapper>
                <Box>
                    <NavigationButton onClick={prevImage}>
                        <ArrowBackIosNewIcon />
                    </NavigationButton>
                </Box>
                <SelectedImage>
                    <img
                        src={
                            images[selectedImageIndex]
                                ? images[selectedImageIndex].src
                                : '/assets/no-image_200x.webp'
                        }
                        alt={images[selectedImageIndex] ? images[selectedImageIndex].altText : 'no image'}
                    />
                </SelectedImage>
                <Box>
                    <NavigationButton onClick={nextImage}>
                        <ArrowForwardIosIcon />
                    </NavigationButton>
                </Box>
            </SelectedImageWrapper>
            {images && images.length > 0 && (
                <ImageSelectorWrapper>
                    {images.map((item, index) => (
                        <ImageWrapper key={item.id}>
                            <ImageThumbnail
                                className={
                                    images[selectedImageIndex].id == item.id
                                        ? 'selected'
                                        : ''
                                }
                                onClick={(e) => changeSelectedImage(e, index)}
                            >
                                <img
                                    src={item.src}
                                    alt={images[selectedImageIndex].altText}
                                />
                            </ImageThumbnail>
                        </ImageWrapper>
                    ))}
                </ImageSelectorWrapper>
            )}
        </StyledWrapper>
    );
};
